module.exports = __webpack_public_path__ + "2f00fc8248dde14d48aaff6b216d54ad.png";